/**
 * Date of birth object for various forms
 */

let days = 32, daysArray = [];
for (let i = 1; i < days; i++) {
  if (i < 10) {
    daysArray.push('0' + i + '')
  }
  else {
    daysArray.push('' + i + '')
  }
}
let years = 90, yearStartAt = new Date().getFullYear() - 17, yearsArray = [];
for (let i = 0; i < years; ++i) {
  let currentYear = --yearStartAt;
  let date = new Date();
  date.setFullYear(currentYear);
  let isLeap = new Date(date.getFullYear() + "-02-29").getMonth() === 1;
  yearsArray.push({value: '' + currentYear + '', isLeap: isLeap})
}

let DobObject = {};
export default DobObject = {
  days: daysArray,
  months: [
    {
      value: '01',
      name: 'January',
      daysCount: 31
    },
    {
      value: '02',
      name: 'February',
      daysCount: 28
    },
    {
      value: '03',
      name: 'March',
      daysCount: 31
    },
    {
      value: '04',
      name: 'April',
      daysCount: 30

    },
    {
      value: '05',
      name: 'May',
      daysCount: 31
    },
    {
      value: '06',
      name: 'June',
      daysCount: 30
    },
    {
      value: '07',
      name: 'July',
      daysCount: 31
    },
    {
      value: '08',
      name: 'August',
      daysCount: 31
    },
    {
      value: '09',
      name: 'September',
      daysCount: 30
    },
    {
      value: '10',
      name: 'October',
      daysCount: 31
    },
    {
      value: '11',
      name: 'November',
      daysCount: 30
    },
    {
      value: '12',
      name: 'December',
      daysCount: 31
    }
  ],
  years: yearsArray
}




// WEBPACK FOOTER //
// ./src/helpers/Utilities/Objects/DateOfBirth/index.js